import { getCategoryListMap } from './courseCardHelper'

export const getGenericCardDetails = (
  item,
  setupData,
  cardsType,
  cardsCategory,
  customCardType,
  customItemField,
) => {
  let categoryList = getCategoryListMap(setupData)
  let itemField = item?.[cardsType]?.itemField

  let imgId
  let title

  if (!customCardType) {
    if (itemField) {
      imgId =
        item?.[cardsType]?.[itemField]?.coverIcon ||
        item?.[cardsType]?.[itemField]?.coverImage ||
        ''
      title = item?.[cardsType]?.[itemField]?.title || item?.[cardsType]?.[itemField]?.name
    } else {
      imgId = item?.[cardsType]?.coverIcon || item?.[cardsType]?.coverImage || ''
      title = item?.[cardsType]?.title || item?.[cardsType]?.name
    }
  } else {
    imgId = item?.[customCardType]?.coverIcon || item?.[customCardType]?.coverImage || ''
    title = item?.[customCardType]?.title || item?.[customCardType]?.name
  }

  const category = categoryList
    ? categoryList?.get(cardsCategory)?.singleTitle || categoryList?.get(cardsCategory)?.name
    : ''

  return { imgId, category, title }
}
